export default __webpack_public_path__ + "static/media/business-cards.7fdfe1f6.jpg";